import type { BuildEvent, Job } from "../../lib/api";

export function buildFailure(job: Job | null, events: BuildEvent[]) {
  const kind = job?.execution?.failure?.kind;
  const studio = job?.execution?.engineVersion === 'studio-v2';
  const savedWork = studio
    ? 'Your business details and any completed work are retained. Try again resumes saved work when an engine correction is available.'
    : 'Your business details are saved. You can start another attempt.';
  if (kind === "delivery") return {
    kind, retry: false,
    title: "Your draft is saved, but its preview connection is unavailable.",
    detail: "The pages don’t need to be generated again. Check back here for the delivery status; your existing site stays available.",
  };
  if (kind === "input" || job?.error === "invalid_brief") return {
    kind: "input", retry: false,
    title: "Some business details need attention.",
    detail: "Review the saved business details before starting another build.",
  };
  if (kind === "infrastructure" || job?.status === "runner_start_failed" || job?.status === "timeout") return {
    kind: "infrastructure", retry: true,
    title: job?.status === "timeout" ? "The build reached its time limit." : "The build service couldn’t finish this attempt.",
    detail: studio ? savedWork : "Your business details are saved. Your existing site stays available while you start another attempt.",
  };
  const renderFailure = job?.error === "render_verification_failed" || events.some(event => {
    const data = event.data as { error?: unknown } | undefined;
    return event.level === "error" && typeof data?.error === "string" && data.error.startsWith("verify_failed:");
  });
  if (renderFailure) return {
    kind: "generation", retry: true,
    title: "The generated site didn’t pass its final checks.",
    detail: studio ? savedWork : "A layout, link or readability check did not pass. Your business details are saved. A new attempt creates another draft.",
  };
  return {
    kind: "generation", retry: true,
    title: "We couldn’t finish this build.",
    detail: savedWork,
  };
}
